import { __assign } from "tslib";
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { DeprecatedBaseButton } from './base-button.comp';
import { getLegacyBaseDriverFromWrapper } from '../../../common/base-driver';
// tslint:disable-next-line:max-line-length
export var createDeprecatedBaseButtonDriver = function (wrapper, buttonType, isHollow) {
    if (isHollow === void 0) { isHollow = false; }
    var buttonClassNames = buttonType ? ".deprecated-button." + buttonType : '.deprecated-button';
    var maybeHollowClass = isHollow ? '.hollow' : ':not(.hollow)';
    var classNames = "" + buttonClassNames + maybeHollowClass;
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, classNames, DeprecatedBaseButton.name);
    return {
        click: function () { return baseDriver.click(); },
        getText: function () { return baseDriver.getText(); },
        isDisabled: function () { return baseDriver.elem.hasAttribute('disabled'); },
        loaderVisible: function () { return baseDriver.isChildVisible('.tiny-loader'); }
    };
};
export var createDeprecatedBaseButton = function (props, children) {
    var element = renderAndMountComponent(React.createElement(DeprecatedBaseButton, __assign({}, props), children));
    return createDeprecatedBaseButtonDriver(element);
};
//# sourceMappingURL=base-button.driver.js.map